module.exports = __webpack_public_path__ + "img/face.5474447c.svg";